(ns ui.components.query-builder.events
  (:require
   [common.util :as cu]
   [re-frame.core :as rf]))

(rf/reg-event-fx
 ::set
 (fn [{db :db} [_ value-path value]]
   {:db (assoc-in db value-path value)}))

(rf/reg-event-fx
 ::remove-item
 (fn [{db :db} [_ db-path index]]
   {:db (update-in db
                   db-path
                   (fn [v]
                     (cu/vec-remove index v)))}))

(rf/reg-event-fx
 ::change-query-item
 (fn [{db :db} [_ db-path item-type]]
   (let [old-item (get-in db db-path)
         old-item-type (:query-type old-item)
         updated-item (cond (= old-item-type item-type)
                            old-item
                            (= item-type :query-type/single-item)
                            {:query-type :query-type/single-item
                             :field      nil
                             :operator   nil
                             :value      nil}
                            :else
                            (assoc old-item :query-type item-type))
         updated (update-in db db-path updated-item)]
     {:db updated})))

(rf/reg-event-fx
 ::add-query-item
 (fn [{db :db} [_ db-path item-type]]
   (let [item (case item-type
                :query-type/single-item
                {:query-type :query-type/single-item
                 :field      nil
                 :operator   nil
                 :value      nil}
                :query-type/or-collection
                {:query-type          :query-type/or-collection
                 :collection-operator :or
                 :rules               []}
                :query-type/and-collection
                {:query-type          :query-type/and-collection
                 :collection-operator :and
                 :rules               []})
         updated (update-in db
                            db-path
                            (fn [v]
                              (vec (concat v [item]))))]
     {:db updated})))
